<section class="orders-footer-section">
  <div class="logo-container">
    <ng-container *ngIf="!isGroup">
      <div class="locations-logo">
        <img *ngIf="location.logoUrl" class="header__image" [src]="location.logoUrl" alt="logo">
      </div>
      <div class="location-info-container">
        <div class="location-name">
          {{location.name}}
        </div>
        <div class="details">
          <div class="location-container" *ngIf="address">
            <span class="material-icons icon-color">room</span>
            {{address}}
          </div>
          <div class="phone-container">
            <span class="material-icons icon-color">phone</span>
            <input class="phone-input" [textMask]="{mask: mask}" [(ngModel)]="location.phone" type="text" disabled/>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="time-container">
    <div class="time">
      {{getTime()}}
    </div>
    <div class="date">
      {{getMoth()}} {{now.getDate()}}, {{now.getFullYear()}}
    </div>
  </div>
</section>
